<template>
  <v-container>
    <v-layout justify-center align-start class="printNone">
      <v-flex xs12>
        <div class="title pa-3 primary--text font-weight-bold">{{ $t('council_license_application') | uppercase }}</div>
      </v-flex>
      <v-layout align-center reverse row wrap class="printNone">
        <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" @click="print(data, 1)">{{ $t('page_license.print') }}</v-btn>
      </v-layout>
    </v-layout>
    <v-layout justify-center align-start class="printNone pa-2" style="">
      <v-flex xs12 style="background-color: dodgerblue" class="pa-2">
        <div class="pa-1 pt-2 pb-2 white--text body2">{{ $t('council_license_message') | uppercase }}</div>
        <div class="pa-1 white--text body2">{{ $t('council_license_message2') | uppercase }}</div>
        <div class="pa-1 white--text body2">{{ $t('council_license_message3') | uppercase }}</div>
      </v-flex>
    </v-layout>
    <v-layout justify-center align-start v-if="Object.keys(data).length === 0" class="printNone">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
          <div class="title pa-3">{{ $t('no_account_selected') }}</div>
          <v-layout row wrap pt-2 justify-center>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap :column="$vuetify.breakpoint.xsOnly">
      <v-layout id="printLayout" justify-center row wrap>
        <v-flex xs12 sm10 md6 class="property_info pl-2 pr-2">
          <v-list two-line dense>
            <v-subheader class="printNone"><h3>{{ $t('application_information') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data._id }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('reference_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.created_at | date }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('application_date') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold" :class="{ 'info--text': data.status === 'in_progress' || data.status === 'kiv', 'primary--text': data.status === 'approved', 'green--text': data.status === 'active', 'error--text': data.status === 'suspended' || data.status === 'cancelled' || data.status === 'rejected' }">{{ $t(data.status) | uppercase }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <br />
          <v-list two-line dense>
            <v-subheader class="printNone"><h3>{{ $t('applicant_information') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item v-if="data.owner.name">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.name.full_name }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('owner_name') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.identity">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(Object.keys(data.owner.identity)[0]) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('identity_type') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.identity">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.identity[Object.keys(data.owner.identity)[0]] }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('identity_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.citizenship }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('citizenship') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(data.owner.gender) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('gender') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.religion }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('religion') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.race }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('race') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(data.owner.marital_status) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('marital_status') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.address && data.owner.address.filter(row => row.type === 'home').length > 0">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.address.filter(row => row.type === 'home')[0].address }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('residential_address') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.address && data.owner.address.filter(row => row.type === 'mail').length > 0">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.address.filter(row => row.type === 'mail')[0].address }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('mailing_address') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.address && data.owner.address.filter(row => row.type === 'mail').length > 0">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.address.filter(row => row.type === 'mail')[0].state }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('state') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.phone && data.owner.phone.filter(row => row.type === 'mobile').length > 0">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.phone.filter(row => row.type === 'mobile')[0].phone }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('mobile_tel') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.phone && data.owner.phone.filter(row => row.type === 'office').length > 0">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.phone.filter(row => row.type === 'office')[0].phone }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('office_tel') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.owner.phone && data.owner.phone.filter(row => row.type === 'home').length > 0">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.owner.phone.filter(row => row.type === 'home')[0].phone }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('residential_tel') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <br />
          <v-list two-line class="d-print-flex">
            <v-subheader class="printNone pb-2" style="background-color: white;"><h3>{{ $t('business_information') }}</h3></v-subheader>
            <v-divider class="printNone" style=" margin-top: -5px"/>
            <v-list-item v-if="data.application">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.application.trading_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('trading_no') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.category">
              <v-list-item-content>
                <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.category.businesstype }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('business_category') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <br />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import QrcodeVue from 'qrcode.vue'
import configurations from '../../configurations'

export default {
  async created () {
    await this.fetchData({ id: this.$route.params.id })
    if (!this.data._id || this.data._id.length === 0) {
      this.$router.go(-1)
    }
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...vuex.mapState({
      data: state => state.licenseForm.data,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      url: configurations.host.eservices + '/#/' + window.location.hash
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'licenseForm/fetchData'
    }),
    hideIC: function (text) {
      var t = text
      var hiddenText = ''
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          if (i < t.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += t[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      var t = text
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    print: async function (data, type) {
      this.loading = true
      function pad (n) { return n < 10 ? '0' + n : n }
      const logo = await this.$store.dispatch('metadata/fetchLogoBase64', { council: 'mdkgu' })
      const ref = this.data._id
      const params = {
        date: pad(new Date(this.data.timestamp).getDate()) + '/' + pad(new Date(this.data.timestamp).getMonth() + 1) + '/' + new Date(this.data.timestamp).getFullYear(),
        logo: logo,
        record: data,
        route: window.location.href,
        title: 'PERMOHONAN LESEN OPERASI'
      }
      const fileName = 'PERMOHONANLESENPERNIAGAAN_' + ref + '.pdf'
      let printWorker = new Worker('print/receipt/license_operation.js')

      // mobile code start
      const storageLocation = cordova.file.externalApplicationStorageDirectory
      var errorCallback = function (e) {
        console.error(e)
      }
      // mobile code end
      printWorker.onmessage = function (response) {
        // const anchor = document.createElement('a')
        // anchor.href = URL.createObjectURL(response.data)
        // anchor.download = fileName
        // document.body.appendChild(anchor)
        // anchor.click()
        // anchor.remove()

      // mobile code start
        window.resolveLocalFileSystemURL(storageLocation,
          function (directory) {
            directory.getFile(fileName, {
              create: true,
              exclusive: false
            },
            function (fileEntry) {
              fileEntry.createWriter(function (writer) {
                writer.onwriteend = function () {
                  cordova.plugins.fileOpener2.open(
                    storageLocation + fileName,
                    'application/pdf',
                    {
                      error: function (e) {
                        console.error('Error status: ' + e.status + ' - Error message: ' + e.message)
                      },
                      success: function () {
                        console.info('file opened successfully')
                      }
                    }
                  )
                }
                writer.seek(0)
                writer.write(response.data)
              }, errorCallback)
            }, errorCallback)
          }, errorCallback)
        this.loading = false
      // mobile code end

        // }
      }
      printWorker.postMessage(params)
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

.text-uppercase {
  text-transform: 'uppercase';
  font-weight: 'bold';
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  nav {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -110px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25% !important;
  }
  .width33 {
    width: 33% !important;
  }
  .width50 {
    width: 50% !important;
  }
  .marginBottom40 {
    margin-bottom: -40px;
  }
}
</style>
